import React, { useState, useEffect } from "react";
import Menu from "./Menu";
import MobileMenu from "./MobileMenu";
import get from "lodash/get";
import filterString from "../common3/filterString";
const initMenuData = require("./tempData/menuData.json");
const initMobileMenuData = require("./tempData/mobileMenuData.json");

const Header = (props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const { extra = {}, effects = {}, runEffect = () => {}, user = null } = props;
  const {
    mobileMenuData = initMobileMenuData,
    menuId,
    className: inlineClassName,
  } = extra;

  useEffect(() => {
    runEffect({
      source: "Selfpoint/getMenu",
      effectId: props.id,
      context: { menuId, asString: true },
    });
  }, []);

  useEffect(() => {
    const body = document.getElementsByTagName("BODY")[0];

    if (mobileMenuOpen) {
      body.classList.add("menu-open");
      return;
    }

    body.classList.remove("menu-open");
  }, [mobileMenuOpen]);

  const menuData = get(effects, props.id, props.menuData);

  let filteredMenuData = [];
  if (menuData) {
    if (typeof menuData === "string") {
      filteredMenuData = JSON.parse(filterString(menuData, props, {}));
    } else {
      filteredMenuData = menuData;
    }
  }

  return (
    <React.Fragment>
      <Menu
        user={user}
        data={menuData ? filteredMenuData : initMenuData}
        setMobileMenuOpen={setMobileMenuOpen}
        inlineClassName={inlineClassName}
      />
      <MobileMenu
        user={user}
        data={menuData ? filteredMenuData : initMenuData}
        open={mobileMenuOpen}
        setOpen={setMobileMenuOpen}
        inlineClassName={inlineClassName}
      />
    </React.Fragment>
  );
};

export default Header;
